/**
 * Runtime configuration service
 * Reads from window.__ENV__ (set by env-config.js at runtime)
 * Falls back to process.env (build-time values)
 */

const getConfig = () => {
  // window.__ENV__ is injected by env-config.js at runtime. In dev mode and
  // in any environment where env-config.js fails to load (404, blocked, race
  // before script executes), the global stays undefined — fall back to {} so
  // every field below resolves via process.env / defaults instead of
  // crashing on an undefined property read.
  const runtimeEnv = (typeof window !== 'undefined' && window.__ENV__) || {};
  const maintenanceEnabledRaw =
    runtimeEnv.MAINTENANCE_BANNER_ENABLED ||
    process.env.REACT_APP_MAINTENANCE_BANNER_ENABLED ||
    'false';
  const maintenanceText =
    runtimeEnv.MAINTENANCE_BANNER_TEXT ||
    process.env.REACT_APP_MAINTENANCE_BANNER_TEXT ||
    '';

  return {
    BACKEND_API: runtimeEnv.REACT_APP_BACKEND_API || process.env.REACT_APP_BACKEND_API || '/api',
    BACKEND_LIVE_API: runtimeEnv.REACT_APP_BACKEND_LIVE_API || process.env.REACT_APP_BACKEND_LIVE_API || '/api',
    MONGODB_URI: runtimeEnv.REACT_APP_MONGODB_URI || process.env.REACT_APP_MONGODB_URI || '/api/node',
    MAINTENANCE_BANNER_ENABLED: String(maintenanceEnabledRaw).toLowerCase() === 'true',
    MAINTENANCE_BANNER_TEXT: maintenanceText.trim(),
  };
};

export default getConfig;
